import Vue from 'vue'
import axios from 'axios'
import Vueaxios from 'vue-axios'

Vue.use(Vueaxios, axios)
const URL = 'https://arit.rmutl.ac.th/survey/api/'
// const URL = 'http://localhost/aritsurvey/api/'
export default {
  Login (obj, success, error) {
    Vue.axios.post(URL + 'login', obj).then(
      response => {
        success(response.data)
      },
      response => {
        error(response)
      }
    )
  },
  getRoundAll (success, error) {
    Vue.axios.get(URL + 'rounds').then(
      response => {
        success(response.data)
      },
      response => {
        error(response)
      }
    )
  },
  getRounds (obj, success, error) {
    Vue.axios.post(URL + 'rounds/roundSearch', obj).then(
      response => {
        success(response.data)
      },
      response => {
        error(response)
      }
    )
  },
  getRoundDetail (roundId, success, error) {
    Vue.axios.get(URL + 'rounds/detail/' + roundId).then(
      response => {
        success(response.data)
      },
      response => {
        error(response)
      }
    )
  },
  getDeleteRound (roundId, success, error) {
    Vue.axios.delete(URL + 'rounds/' + roundId).then(
      response => {
        success(response.data)
      },
      response => {
        error(response)
      }
    )
  },
  newRound (obj, success, error) {
    Vue.axios.post(URL + 'rounds', obj).then(
      response => {
        success(response.data)
      },
      response => {
        error(response)
      }
    )
  },
  updateRound (obj, success, error) {
    Vue.axios.put(URL + 'rounds', obj).then(
      response => {
        success(response.data)
      },
      response => {
        error(response)
      }
    )
  },
  getYear (success, error) {
    Vue.axios.get(URL + 'rounds/year').then(
      response => {
        success(response.data)
      },
      response => {
        error(response)
      }
    )
  },
  getGroup (key, success, error) {
    Vue.axios.get(URL + 'question/' + key).then(
      response => {
        success(response.data)
      },
      response => {
        error(response)
      }
    )
  },
  getMapGroup (id, success, error) {
    Vue.axios.get(URL + 'group/' + id).then(
      response => {
        success(response.data)
      },
      response => {
        error(response)
      }
    )
  },
  updateGroupSort (obj, success, error) {
    Vue.axios.put(URL + 'group/sort', obj).then(
      response => {
        success(response.data)
      },
      response => {
        error(response)
      }
    )
  },
  deleteGroup (id, success, error) {
    Vue.axios.delete(URL + 'group/' + id).then(
      response => {
        success(response.data)
      },
      response => {
        error(response)
      }
    )
  },
  addGroup (obj, success, error) {
    Vue.axios.post(URL + 'group', obj).then(
      response => {
        success(response.data)
      },
      response => {
        error(response)
      }
    )
  },
  updateGroup (obj, success, error) {
    Vue.axios.put(URL + 'group', obj).then(
      response => {
        success(response.data)
      },
      response => {
        error(response)
      }
    )
  },
  getRoundList (success, error) {
    Vue.axios.get(URL + 'rounds').then(
      response => {
        success(response.data)
      },
      response => {
        error(response)
      }
    )
  },
  addQuestion (obj, success, error) {
    Vue.axios.post(URL + 'question', obj).then(
      response => {
        success(response.data)
      },
      response => {
        error(response)
      }
    )
  },
  editQuestion (obj, success, error) {
    Vue.axios.put(URL + 'question', obj).then(
      response => {
        success(response.data)
      },
      response => {
        error(response)
      }
    )
  },
  removeQuestion (id, success, error) {
    Vue.axios.delete(URL + 'question/' + id).then(
      response => {
        success(response.data)
      },
      response => {
        error(response)
      }
    )
  },
  ReportFac (token, success, error) {
    Vue.axios.get(URL + 'report/faculty/' + token).then(
      response => {
        success(response.data)
      },
      response => {
        error(response)
      }
    )
  },
  ReportGender (token, success, error) {
    Vue.axios.get(URL + 'report/gender/' + token).then(
      response => {
        success(response.data)
      },
      response => {
        error(response)
      }
    )
  },
  updateQuestsort (obj, success, error) {
    Vue.axios.put(URL + 'question/sort', obj).then(
      response => {
        success(response.data)
      },
      response => {
        error(response)
      }
    )
  },
  getRole (success, error) {
    Vue.axios.get(URL + 'role').then(
      response => {
        success(response.data)
      },
      response => {
        error(response)
      }
    )
  },
  getMenus (id, success, error) {
    Vue.axios.get(URL + 'role/permission/' + id).then(
      response => {
        success(response.data)
      },
      response => {
        error(response)
      }
    )
  },
  updateMenus (obj, success, error) {
    Vue.axios.put(URL + 'role/permission', obj).then(
      response => {
        success(response.data)
      },
      response => {
        error(response)
      }
    )
  },
  seachUser (obj, success, error) {
    Vue.axios.post(URL + 'user/search', obj).then(
      response => {
        success(response.data)
      },
      response => {
        error(response)
      }
    )
  },
  researchuserAD (obj, success, error) {
    Vue.axios.post(URL + 'user/checkUsername', obj).then(
      response => {
        success(response.data)
      },
      response => {
        error(response)
      }
    )
  },
  addUser (obj, success, error) {
    Vue.axios.post(URL + 'user', obj).then(
      response => {
        success(response.data)
      },
      response => {
        error(response)
      }
    )
  },
  updateUser (obj, success, error) {
    Vue.axios.put(URL + 'user', obj).then(
      response => {
        success(response.data)
      },
      response => {
        error(response)
      }
    )
  },
  removeUser (id, success, error) {
    Vue.axios.delete(URL + 'user/' + id).then(
      response => {
        success(response.data)
      },
      response => {
        error(response)
      }
    )
  },
  getChoiceData (id, success, error) {
    Vue.axios.get(URL + 'choice/' + id).then(
      response => {
        success(response.data)
      },
      response => {
        error(response)
      }
    )
  },
  addChoice (obj, success, error) {
    Vue.axios.post(URL + 'choice', obj).then(
      response => {
        success(response.data)
      },
      response => {
        error(response)
      }
    )
  },
  deleteChoice (id, success, error) {
    Vue.axios.delete(URL + 'choice/' + id).then(
      response => {
        success(response.data)
      },
      response => {
        error(response)
      }
    )
  }
}



// WEBPACK FOOTER //
// ./src/services/service.js